import metaIntro from './metaIntro.jpg';
import interview from './interview.png';
import muymtradesmall from './muymtradesmall.png';
import thouthbwgaismall from './thouthbwgaismall.png';
import pnaacl from './pnaacl.png';
import yacht from './yacht.png';
import handwrite from './handwrite.jpg';
import psmall from './psmall.jpg';
import breakout from './Breakout2small.jpg';
import gravitationsdrehwaage from './Gravitationsdrehwaage_Prinzip.png';

const projectImages: Record<string, string> = {
    'metaIntro.jpg': metaIntro,
    'interview.png': interview,
    'muymtradesmall.png': muymtradesmall,
    'thouthbwgaismall.png': thouthbwgaismall,
    'pnaacl.png': pnaacl,
    'yacht.png': yacht,
    'handwrite.jpg': handwrite,
    'psmall.jpg': psmall,
    'Breakout2small.JPG': breakout,
    'Gravitationsdrehwaage_Prinzip.png': gravitationsdrehwaage,
};

export default projectImages;
